<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name" #title>パスワード変更</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <!-- ここから画面の内容を記述 -->
        <div class="split_two_part">
          <div class="column-list">
            <label class="list-input-title">現在のパスワード</label>
            <div class="list-input-content input-wrapper">
              <input class="text-label-required" [(ngModel)]="kymw9006Model.password" maxlength="30" [restrict]="'[ -￮]'"
                [type]="isPasswordVisible1 ? 'text': 'password'" plessInputTextSub #txti_Password autocomplete="off">
              <button tabindex="-1" (mousedown)="eventEye_MouseDownHandler($event, 1)">
                <fa-icon [class]="isPasswordVisible1 ? 'fa-eye': 'fa-eye-slash'" [icon]="iconEyeDisp1"></fa-icon>
              </button>
            </div>
            <label class="list-input-title">新しいパスワード</label>
            <div class="list-input-content input-wrapper">
              <input class="text-label-required" [(ngModel)]="kymw9006Model.newPassword" maxlength="30"
                [type]="isPasswordVisible2 ? 'text': 'password'" plessInputTextSub #txti_NewPassword autocomplete="off">
              <button tabindex="-1" (mousedown)="eventEye_MouseDownHandler($event, 2)">
                <fa-icon [class]="isPasswordVisible2 ? 'fa-eye': 'fa-eye-slash'" [icon]="iconEyeDisp2"></fa-icon>
              </button>
            </div>
            <label class="list-input-title">新しいパスワード(確認)</label>
            <div class="list-input-content input-wrapper">
              <input class="text-label-required" [(ngModel)]="kymw9006Model.reNewPassword" maxlength="30"
                [type]="isPasswordVisible3 ? 'text': 'password'" plessInputTextSub #txti_ReNewPassword autocomplete="off">
              <button tabindex="-1" (mousedown)="eventEye_MouseDownHandler($event, 3)">
                <fa-icon [class]="isPasswordVisible3 ? 'fa-eye': 'fa-eye-slash'" [icon]="iconEyeDisp3"></fa-icon>
              </button>
            </div>
          </div>
          <div>
            <h1>パスワード設定ルール</h1>
            <div class="element-column">
              <label>
                ➀下記の4種類の文字を組み合わせて、<br>
                <span class="indent">8桁以上(半角)のパスワードをご設定ください。</span><br>
                <span class="indent">・英大文字（ABC...XYZ）</span><br>
                <span class="indent">・英小文字（abc...xyz）</span><br>
                <span class="indent">・数字（0123456789）</span><br>
                <span class="indent">・記号</span><br>
              </label>
              <label>
                ➁過去に設定したパスワードは使いまわしできません。<br>
                <span class="indent">※過去2世代以内に使用したパスワードは設定できません。</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" (click)="eventUpdate_CLICKHandler()">更新</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>